import { useFormik } from "formik";
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRelatedTransactions,
  resetRelatedTransactions,
} from "../../../redux/slice/accounting/accountingSlice";
import { BounceLoader } from "react-spinners";
import moment from "moment/moment";

const Reversal = ({ handleClose, showModal, transaction_id, data }) => {
  const { related_transactions, isLoading } = useSelector(
    (state) => state?.accounting
  );
  const form = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    //   this for the modal form reset
    if (!showModal) {
      handleClose(form);
      dispatch(resetRelatedTransactions());
      return;
    }
    dispatch(getRelatedTransactions(transaction_id));
  }, [showModal]);

  return (
    <div>
      {related_transactions && (
        <form className='d-flex mt-3 flex-column' ref={form}>
          <div className='px-2'>
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end'>
                <label
                  htmlFor='username'
                  className={`form-label text-grey mt-1`}
                >
                  Transaction ID
                </label>
              </div>
              <div className='col-md-6'>
                <input
                  type='text'
                  id='account_name'
                  name='account_name'
                  className={`form-control`}
                  // value={values?.account_name}
                  defaultValue={data?.transaction_id}
                  readOnly
                />
              </div>
            </div>
            {data?.reversed === 1 ? (
              <div className='row mb-2'>
                <div className='col-md-4 text-end sm-text-end'>
                  <label
                    htmlFor='username'
                    className={`form-label text-grey mt-1`}
                  >
                    Transaction Status
                  </label>
                </div>
                <div className='col-md-6'>
                  <input
                    type='text'
                    id='transaction_status'
                    name='transaction_status'
                    className={`form-control`}
                    // value={values?.account_name}
                    defaultValue={data?.reversed === 1 ? "Reversed" : null}
                    readOnly
                  />
                </div>
              </div>
            ) : null}
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end pt-1'>
                <label
                  htmlFor='transaction_type'
                  className='form-label text-grey'
                >
                  Transaction Type
                </label>
              </div>
              <div className='col-md-6'>
                <input
                  className='form-control'
                  name='transaction_type'
                  // value={values?.transaction_type}
                  type='text'
                  id='manual_entry'
                  defaultValue={
                    data?.transaction_type !== 3
                      ? data?.manual_entry === "Yes"
                        ? "Manual Entry"
                        : "Automatic"
                      : "Migrated"
                  }
                  readOnly
                />
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end pt-1'>
                <label
                  htmlFor='transaction_type'
                  className='form-label text-grey'
                >
                  Branch
                </label>
              </div>
              <div className='col-md-6'>
                <input
                  className='form-control'
                  name='transaction_type'
                  // value={values?.transaction_type}
                  type='text'
                  id='transaction_type'
                  defaultValue={data?.office_name}
                  readOnly
                />
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end pt-1'>
                <label
                  htmlFor='transaction_type'
                  className='form-label text-grey'
                >
                  Booking Date
                </label>
              </div>
              <div className='col-md-6'>
                <input
                  className='form-control'
                  name='transaction_type'
                  // value={values?.transaction_type}
                  defaultValue={data?.entry_date}
                  type='date'
                  id='transaction_type'
                  readOnly
                />
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end pt-1'>
                <label
                  htmlFor='transaction_type'
                  className='form-label text-grey'
                >
                  Created By
                </label>
              </div>
              <div className='col-md-6'>
                <input
                  className='form-control'
                  name='transaction_type'
                  value={
                    data?.createdby_id +
                    " - " +
                    moment(data?.created_at).format("D/M/Y")
                  }
                  type='text'
                  id='transaction_type'
                  readOnly
                />
              </div>
            </div>
            <div className='row mb-2'>
              <div className='col-md-4 text-end sm-text-end pt-1'>
                <label
                  htmlFor='transaction_type'
                  className='form-label text-grey'
                >
                  Description
                </label>
              </div>
              <div className='col-md-6'>
                <textarea
                  className='form-control'
                  name='transaction_type'
                  // value={values?.transaction_type}
                  defaultValue={data?.description}
                  type='text'
                  id='transaction_type'
                  readOnly
                  cols='30'
                  rows='3'
                ></textarea>
              </div>
            </div>
          </div>
          <div className='mb-2'>
            <div className='row px-2'>
              <div className='col-md-6 mt-2'>
                <h4 className='fw-bold text-dark'>Debit</h4>
                {related_transactions?.journal
                  ?.filter((item) => item.transaction_type === 2)
                  .map((item, i) => (
                    <div className='d-flex gap-1 mt-2' key={i}>
                      <div className='form-control text-capitalize' readOnly>
                        {item?.account_name?.toLowerCase()}
                      </div>
                      <input
                        readOnly
                        className='form-control w-25 text-center p-1'
                        value={item?.amount}
                      />
                    </div>
                  ))}
                <div className='d-flex gap-1 justify-content-between mt-2'>
                  <h5 className='p-0' readOnly>
                    Total Debit
                  </h5>
                  <input
                    type='text'
                    className='form-control p-1 w-25'
                    value={related_transactions?.journal
                      ?.filter((item) => item.transaction_type === 2)
                      .reduce(
                        (acc, currenValue) =>
                          (acc += parseInt(currenValue?.amount)),
                        0
                      )}
                    readOnly
                  />
                </div>
              </div>
              <div className='col-md-6 mt-2'>
                <h4 className='fw-bold text-dark'>Credit</h4>
                {related_transactions?.journal
                  ?.filter((item) => item.transaction_type === 1)
                  .map((item, i) => (
                    <div className='d-flex gap-1 mt-2' key={i}>
                      <div className='form-control text-capitalize' readOnly>
                        {item?.account_name?.toLowerCase()}
                      </div>
                      <input
                        readOnly
                        className='form-control w-25 text-center p-1'
                        value={item?.amount}
                      />
                    </div>
                  ))}
                <div className='d-flex gap-1 justify-content-between mt-2'>
                  <h5 className='p-0' readOnly>
                    Total Credit
                  </h5>
                  <input
                    type='text'
                    className='form-control p-1 w-25'
                    value={related_transactions?.journal
                      ?.filter((item) => item.transaction_type === 2)
                      .reduce(
                        (acc, currenValue) =>
                          (acc += parseInt(currenValue?.amount)),
                        0
                      )}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
      {isLoading && (
        <div className='mx-auto w-100 d-flex justify-content-center transparent-primary z-1000 mb-2 p-1'>
          <div className='text-black fs-4 mx-auto fw-bold '>
            <BounceLoader
              color='#090b8f'
              loading={true}
              // cssOverride={override}
              size={50}
              aria-label='Loading Spinner'
              data-testid='loader'
              className='ms-3'
            />
            <span className=''>Please wait...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reversal;
